import { inject } from '@angular/core';
import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { SessionWatcher } from './session-watcher';

const AUTH_RETRY_ATTEMPTED = new HttpContextToken<boolean>(() => false);

const isApiRequest = (url: string): boolean => url.startsWith('/api/') || url === '/api';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApiRequest(req.url) || req.context.get(AUTH_RETRY_ATTEMPTED)) {
    return next(req);
  }
  const sessionWatcher = inject(SessionWatcher);
  return next(req).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
        return throwError(() => error);
      }
      return from(sessionWatcher.ensureFreshAccessToken()).pipe(
        switchMap((refreshed) => {
          if (!refreshed) {
            return throwError(() => error);
          }
          const retried = req.clone({
            context: req.context.set(AUTH_RETRY_ATTEMPTED, true),
          });
          return next(retried);
        }),
      );
    }),
  );
};
